import { Component } from '@angular/core';

@Component({
    selector: 'app-side-list',
    templateUrl: './side-list.component.html',
    styleUrls: ['./side-list.component.scss'],
})
export class SideListComponent {
    constructor() {}
}
